import styled from 'styled-components';
import { RefObject, useCallback, useState, MouseEvent } from 'react';
import { SelectionKnobs } from './selection-knobs';
import { IBaseComponentProps } from '../../types';
import { MoveableSurface } from '../../moveable';
import { selectStyleByState } from '../utils';

interface ISlideAreaProps extends IBaseComponentProps {
    disabled?: boolean;
    unitSize: number;
    start: number;
    end: number;
    isHorizontallyAligned: boolean;
    inRangeMode: boolean;
    onClick(ev: MouseEvent): void;
    onEndChange(endPosition: number): void;
    onStartChange(startPosition: number): void;
}

function SlideAreaBase(props: ISlideAreaProps) {
    const {
        className, isHorizontallyAligned, inRangeMode, disabled, unitSize, elementRef,
        start, end, onClick, onEndChange, onStartChange
    } = props;
    const [hovered, setHoveredState] = useState(false);

    const onMouseEnter = useCallback(() => {
        setHoveredState(true);
    }, []);

    const onMouseLeave = useCallback(() => {
        setHoveredState(false);
    }, []);

    return (
        <MoveableSurface context={{ containerRef: elementRef }}>{
            (ref) => (
                <div className={className}
                    ref={ref as RefObject<HTMLDivElement>}
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    onClick={onClick}>
                    <SelectionKnobs isHorizontallyAligned={isHorizontallyAligned} unitSize={unitSize}
                        hovered={hovered} start={start} end={end} inRangeMode={inRangeMode}
                        disabled={disabled} onEndChange={onEndChange} onStartChange={onStartChange} />
                </div>
            )
        }</MoveableSurface>
    );
}

export const SlideArea = styled(SlideAreaBase).attrs({
    className: String('ap-slider-slideArea')
})`
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? '0.5' : 'unset')};
    position: relative;
    height: ${({ isHorizontallyAligned, theme: { slider: { composites: { slideArea } } } }) => isHorizontallyAligned ? slideArea.thickness : '100%'};
    width: ${({ isHorizontallyAligned, theme: { slider: { composites: { slideArea } } } }) => isHorizontallyAligned ? '100%' : slideArea.thickness};
    border-radius: ${({ theme: { slider: { composites: { slideArea } } } }) => slideArea.borderRadius};
    background-color: ${({ theme, disabled }) => selectStyleByState(theme, disabled ? 'disabled' : 'default').slideArea.emptyAreaBackground};

    .ap-moveable-wrapper .moveable-control.moveable-direction {
        opacity: 0;
        cursor: pointer;
    }
`;
